/*******************************************************************************
  설  명 : 홈페이지 > 유료회원전환
  작성자 : 송영석
  작성일 : 2020-06-08
*******************************************************************************/
import { Component, OnInit, NgZone } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';

import { config } from '@app/service/config.service';
import { CommonService } from '@app/service/common.service';

import { HAuthService } from '@home/service/auth.service';
import { HMemberService } from '@home/service/member.service';

import { PaidMemberBankComponent } from '@home/page/member/mypage/paid-member/paid-member-step1/paid-member-bank/paid-member-bank.component';

import { O2OZCMS } from '@app/components/o2oz-cms/o2oz-cms.component';

declare global {
  interface Window {
    fn: any;
  }
}

const options: NgbModalOptions = {
  backdrop: 'static',
  keyboard: false,
  size: 'lg',
  centered: true,
  windowClass: 'modal-690'
};

@Component({
  selector: 'app-paid-member-step1',
  templateUrl: './paid-member-step1.component.html',
  styleUrls: ['./paid-member-step1.component.scss']
})
export class PaidMemberStep1Component extends O2OZCMS implements OnInit {

  public agree1 = false;
  public agree2 = false;

  public memberInfo: any = {};

  /* 기업아이디 리스트 */
  public memberList: any = [];

  /* 주 담당자 여부 */
  public majorYn = true;

  /*******************************************************************************
    설  명 : 생성자
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  constructor(
    router: Router,
    commonService: CommonService,
    activatedRoute: ActivatedRoute,
    toastrService: ToastrService,
    private ngZone: NgZone,
    private modalService: NgbModal,
    private authService: HAuthService,
    private memberService: HMemberService,
  ) {
    // 상위 클래스에 router 전달
    super(router, commonService, activatedRoute, toastrService);

  }

  ngOnInit(): void {
    this.authService.getHomeLoginData.subscribe(data => {
      this.memberInfo = data;

      // 기업회원 주 담당자 여부 확인
      if (data['companySeq']) {
        this.getCompanyMember(data['companySeq']);
      }
    });

    window.fn  = window.fn || {};
    window.fn.namespace = window.fn.namespace || {};
    window.fn.namespace.payFunc = this.payFunc.bind(this);
  }

  /*******************************************************************************
    설  명 : 결제 실행 후 ngZone 실행
  *******************************************************************************/
  payFunc( response: any ) {
    this.ngZone.run(() => this.payCallback( response ));
  }

  /*******************************************************************************
    설  명 : 결제 인증 콜백
  *******************************************************************************/
  payCallback( response: any ) {
    // console.log(response);
    if ( response.resultCode === true ) {
      this.toastrService.success( '정상적으로 결제되었습니다.' , '유료회원 결제');
      this.router.navigate(['/member/mypage/paidmember/step2']);
    } else {
      this.toastrService.error( response.resultMsg, '유료회원 결제');
    }
  }

  /*******************************************************************************
    설  명 : 결제하기
  *******************************************************************************/
  setPayment( type: any ) {
    // console.log(this.agree);
    if ( this.agree1 === false ) {
      this.toastrService.error('유료회원전환을 원하시면 이용약관에 동의하셔야 합니다.', '');
    } else if ( this.agree2 === false ) {
      this.toastrService.error('유료회원전환을 원하시면 개인정보처리방침에 동의하셔야 합니다.', '');
    } else {
      if ( type === 'C' ) {
        window.open( config.baseUrl + '/epay/stdpay/INIStdPay/INIStdPayRequest.php', '', 'width=1000,height=700,scrollbar=yes' );
      } else if ( type === 'B' ) {
        this.openBank();
      } else {
        this.toastrService.error('정상적으로 실행하시기 바랍니다.', '');
      }
    }
  }

  /*******************************************************************************
    설  명 : 무통장 입금안내
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  openBank() {
    const modalRef = this.modalService.open(PaidMemberBankComponent, options);

    modalRef.result.then((result) => {
      if ( result ) {
      }
    }, (reason) => {
    });
  }

  /*******************************************************************************
    설  명 : 기업회원 리스트
    입력값 : 없음
    리턴값 : 주담당자 true / 일반 false
  *******************************************************************************/
  async getCompanyMember(companySeq) {
    await this.memberService.getCompanyMember(companySeq).then( response => {
      if ( response.ResultCode ) {

        const idx = response.data.findIndex(item => {
          return item.memNo === this.memberInfo.memNo && item.majorYn === '1';
        });

        console.log( idx );
        // 주담당자 여부 확인
        if (idx > -1) {
          this.majorYn = true;
        }
      } else {
        this.majorYn = false;
      }
    });
  }

  /*******************************************************************************
    설  명 : 이전 페이지
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  prevPage() {
    this.router.navigate([ '/contents' ], { queryParams: { menu_seq: '248' }});
  }

}
